import { Link } from "react-router-dom";
import logo from "../assets/images/white-logo.png";

function Footer() {
  return (
    <footer id="newsletter">
      <div className="container">
        <div className="row">

          {/* About */}
          <div className="col-lg-3 col-12">
            <div className="footer-widget">
              <h4>About Our Company</h4>

              <div className="logo">
                <img src={logo} alt="logo" />
              </div>

              <p>
                Empowering businesses with verified, actionable data intelligence.
                India's future-ready data platform.
              </p>
            </div>
          </div>

          {/* Services */}
          <div className="col-lg-3 col-7">
            <div className="footer-widget">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services">Data Selling</Link></li>
                <li><Link to="/services">Data Enrichment</Link></li>
                <li><Link to="/services">Custom Reports</Link></li>
                <li><Link to="/services">API Access</Link></li>
                <li><Link to="/services">Consulting</Link></li>
              </ul>
            </div>
          </div>

          {/* Company */}
          <div className="col-lg-3 col-5">
            <div className="footer-widget">
              <h4>Company</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-3">
            <div className="footer-widget">
              <h4>Contact Us</h4>
              <p>Mahaveer Nagar, Kota(Raj.)</p>
              <p><a href="tel:9929075545">992-907-5545</a></p>
              <p><a href="mailto:info@datroniq.io">info@datroniq.io</a></p>
            </div>
          </div>

          {/* Copyright */}
          <div className="col-lg-12">
            <div className="copyright-text">
              <p>Copyright © 2026 DatroniQ. All Rights Reserved.</p>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;